<app-full-screen-slider [active]="active"
                        [photo]="activeSlide"
                        (activeEmit)="active = $event"
                        (clickLeftEmit)="clickSlider('left')"
                        (clickRightEmit)="clickSlider('right')"
/>
<div class="article-container">
    <div class="article" *ngFor="let slide of slides; index as i">
        <img [src]="getImageUrl(slide)" alt="slide" (click)="open(i, slide)">
    </div>
</div>
